import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '@/components/SEO';
import LanguageSwitcher from '@/components/LanguageSwitcher';

const About = () => {
  const { i18n } = useTranslation();
  const isDe = i18n.language?.startsWith('de');

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: isDe ? 'Über DUMONGO' : 'About DUMONGO',
    url: 'https://dumongo.com/about',
    description: isDe
      ? 'Die Geschichte hinter DUMONGO.COM – das satirische Kunstprojekt, in dem Menschen Geld für absolut nichts verbrennen.'
      : 'The story behind DUMONGO.COM – the satirical art project where people burn money for absolutely nothing.',
  };

  return (
    <div className="min-h-screen bg-background px-4 py-16">
      <SEO
        title={isDe ? 'Über das Experiment' : 'About the Experiment'}
        description={
          isDe
            ? 'Was ist DUMONGO? Ein satirisches Kunstprojekt über Konsum, Status und das Internet. Lerne die Philosophie hinter der dümmsten Highscore-Liste der Welt kennen.'
            : 'What is DUMONGO? A satirical art project about consumerism, status, and the internet. Learn the philosophy behind the dumbest highscore list in the world.'
        }
        path="/about"
        jsonLd={jsonLd}
      />
      <header className="fixed top-0 right-0 z-50 p-4">
        <LanguageSwitcher />
      </header>

      <article className="mx-auto max-w-3xl space-y-8">
        <h1 className="text-4xl md:text-6xl font-bold terminal-glow">
          {isDe ? '[ ÜBER DAS EXPERIMENT ]' : '[ ABOUT THE EXPERIMENT ]'}
        </h1>

        <section className="terminal-border p-6 space-y-4">
          <h2 className="text-2xl font-bold text-primary">
            {isDe ? 'Was ist DUMONGO?' : 'What is DUMONGO?'}
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            {isDe
              ? 'DUMONGO.COM ist die dümmste Highscore-Liste des Internets. Echte Menschen verbrennen echtes Geld – und bekommen dafür absolut nichts außer einem Platz auf einer öffentlichen Bestenliste. Es ist Performance-Kunst, soziales Experiment und Internet-Satire in einem.'
              : 'DUMONGO.COM is the dumbest highscore list on the internet. Real humans burn real money — and receive absolutely nothing in return except a spot on a public leaderboard. It is performance art, social experiment, and internet satire all in one.'}
          </p>
        </section>

        <section className="terminal-border p-6 space-y-4">
          <h2 className="text-2xl font-bold text-primary">
            {isDe ? 'Warum existiert das?' : 'Why does this exist?'}
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            {isDe
              ? 'Wir wollten wissen: Wie viel würden Menschen für absolut nichts bezahlen? Die Antwort hat uns selbst überrascht. DUMONGO ist ein Kommentar zu Konsum, Influencer-Kultur und der absurden Ökonomie der Aufmerksamkeit.'
              : 'We wanted to know: how much would people pay for absolutely nothing? The answer surprised even us. DUMONGO is a commentary on consumerism, influencer culture, and the absurd economy of attention.'}
          </p>
        </section>

        <section className="terminal-border p-6 space-y-4">
          <h2 className="text-2xl font-bold text-primary">
            {isDe ? 'Die Vokabeln' : 'The Vocabulary'}
          </h2>
          <ul className="space-y-2 text-muted-foreground">
            <li><strong className="text-primary">Mongo</strong> — {isDe ? 'jemand, der mitgemacht hat' : 'someone who has joined the experiment'}</li>
            <li><strong className="text-primary">Biggest Idiot</strong> — {isDe ? 'der All-Time-Spender' : 'the all-time top donor'}</li>
            <li><strong className="text-primary">Mongo of the Month</strong> — {isDe ? 'der Monatsmeister' : 'the monthly champion'}</li>
            <li><strong className="text-primary">The Experiment</strong> — DUMONGO.COM</li>
          </ul>
        </section>

        <nav className="flex gap-4 flex-wrap">
          <Link to="/" className="terminal-border px-6 py-3 hover:bg-primary hover:text-primary-foreground transition-colors">
            {isDe ? '← ZURÜCK ZUM LEADERBOARD' : '← BACK TO LEADERBOARD'}
          </Link>
          <Link to="/faq" className="terminal-border px-6 py-3 hover:bg-primary hover:text-primary-foreground transition-colors">
            FAQ →
          </Link>
        </nav>
      </article>
    </div>
  );
};

export default About;
